module.exports = __webpack_public_path__ + "media/images/pc/brands/tvb/main-visual-text-19eadf471b08090953bd1398d8a94e7f.svg";